<template>
    <div class="yunbird-pagination">
        <div class="pagination-container">
            <div class="page-item pre" :disabled="currentpage == 1" @click="pre" v-text="'<<'"></div>
            <div class="page-item"
                 :class="{'page-sel': currentpage == page}"
                 @click="pageTo(page)"
                 v-for="(page) in pages" :key="`page${page}`">
                {{page}}
            </div>
            <div class="page-item next" :disabled="currentpage == totalPage"  @click="next" v-text="'>>'"></div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            totalPage: {
                type: Number,
                default: 0
            }
        },
        data(){
            return{
                currentpage: 1,
            }
        },
        computed:{
            pages(){
                var ps = [];
                if (this.totalPage > 0) {
                    for (let i = 0; i < this.totalPage; i++) {
                        ps.push(i+1);
                    }
                }
                return ps;
            }
        },
        created(){

        },
        methods:{
            pre(){
                if (this.currentpage == 1) {
                    return;
                }
                this.currentpage -= 1;
                this.pageTo(this.currentpage);
            },
            next(){
                if (this.currentpage == this.totalPage) {
                    return;
                }
                this.currentpage += 1;
                this.pageTo(this.currentpage);
            },
            pageTo(page){
                this.currentpage = page;
                this.$emit('pageTo',page);
            }
        }
    }
</script>

<style lang="scss" type="text/scss" scoped>

    .yunbird-pagination{
        width: 100%;
        display: flex;
        justify-content: flex-end;
        height: .5rem;

        .pagination-container{
            display: flex;
            align-items: center;

            .page-item{
                font-size: .24rem;
                color: #959595;
                background-color: white;
                border: 1px solid #959595;
                border-left: none;
                height: .5rem;
                width: .5rem;
                line-height: .52rem;
                text-align: center;
                cursor: pointer;
            }

            .page-sel{
                background-color: #545454;
                color: #ffffff;
            }

            .pre{
                border-bottom-left-radius: .1rem;
                border-top-left-radius: .1rem;
                border-left: 1px solid #959595;
                font-size: .1rem;
                font-weight: bold;
            }

            .next{
                border-bottom-right-radius: .1rem;
                border-top-right-radius: .1rem;
                font-size: .1rem;
                font-weight: bold;
            }
        }
    }

</style>
